<template>
  <a-spin :spinning="loading">
    <a-list
      item-layout="horizontal"
      :data-source="data"
    >
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a slot="actions" @click="diligenciarFormulario(item)">Diligenciar</a>
        <a-list-item-meta>
          <a slot="title">{{ item.name }}</a>
          <a-progress slot="description" :percent="parseInt(item.porcentaje)" status="active"/>
        </a-list-item-meta>
        <div>
        </div>
      </a-list-item>
    </a-list>

  </a-spin>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['evaluacion', 'evaluado'],
    data () {
      return {
        loading: false,
        data: []
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.cargarFormularios()
    },
    methods: {
      cargarFormularios () {
        if (this.evaluacion) {
          this.loading = true
          this.httpClient.getInstance().get('evaluaciones/formularios/disponibles', {
            params: {
              id_evaluation: this.evaluacion.id_evaluation,
              id_emp: this.evaluado.cod_evaluado
            }
          })
            .then(response => {
              this.data = response.data
            })
            .catch(error => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible consultar los formularios.'))
            })
            .then(() => {
              this.loading = false
            })
        }
      },
      diligenciarFormulario (formulario) {
        let fnAbrirVentana = (idFormFillout) => {
          let routeData = this.$router.resolve({
            name: 'FormFillout',
            query: {fillOutId: idFormFillout}
          })
          window.open(routeData.href, '_blank')
        }

        if (JsUtils.isEmpty(formulario.id_forms_fillout)) {
          this.loading = true
          this.httpClient.getInstance().post('evaluaciones/formularios/registrar_formulario', {
            id_form: formulario.id,
            id_emp: this.evaluado.cod_evaluado,
            id_person: this.evaluado.evaluado
          }).then(response => {
            this.loading = true
            fnAbrirVentana(response.data.id_forms_fillout)
            this.cargarFormularios()
          })
            .catch(error => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible regisrar el formulario.'))
            })
        } else {
          fnAbrirVentana(formulario.id_forms_fillout)
        }
      }
    },
    watch: {
      evaluacion () {
        this.cargarFormularios()
      },
      evaluado () {
        this.cargarFormularios()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/EvaluacionesFormularios.vue